const ModalState = {
    Profile : false,
    Historic : false,
    ShowFile : false,
    PhotoCrop : false,
    DetailsUser : false,
    Confirmation : false,
    RecoverEmail : false,
    ReturnResponse : false,

    EditOrNewDownloads : false
};

const ModalData = {
    Profile : {},
    Historic : {},
    ShowFile : {},
    PhotoCrop : {},
    DetailsUser : {},
    Confirmation : {},
    RecoverEmail : {},
    ReturnResponse : {},

    EditOrNewDownloads : {}
}

const NotifyModalObserver = {
    Profile : [],
    Historic : [],
    ShowFile : [],
    PhotoCrop : [],
    DetailsUser : [],
    Confirmation : [],
    RecoverEmail : [],
    ReturnResponse : [],

    EditOrNewDownloads : []
}

const NotifyModalData = {
    Profile : [],
    Historic : [],
    ShowFile : [],
    PhotoCrop : [],
    DetailsUser : [],
    Confirmation : [],
    RecoverEmail : [],
    ReturnResponse : [],

    EditOrNewDownloads : []
}

// ModalData
export function SetModalData(modal, data){
    ModalData[modal] = data;
    NotifyModalData[modal].forEach(element => {
        element(data);
    });
}
export function GetModalData(key, value){
    return ModalData[key][value];
}
export function RegisterModalData(modal, func){
    NotifyModalData[modal].push(func);
}

// ModalState
export function SetModalState(modal, state){
    ModalState[modal] = state;
    NotifyModalObserver[modal].forEach(element => {
        element(state);
    });
}
export function GetModalState(key, value){
    return ModalState[key][value];
}
export function RegisterModalObserver(modal, func){
    NotifyModalObserver[modal].push(func);
}
